(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets/assets/javascripts/next/areas/pick/pick.js') >= 0) return;  svs.modules.push('/modules/tickets/assets/javascripts/next/areas/pick/pick.js');
'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const tickets = svs.tickets;
const BottomSheet = tickets.next.components.bottomsheet.BottomSheet;
const TicketCarouselStage = tickets.next.components.ticketCarousel.TicketCarouselStage;
const TICKET_COUNT = tickets.next.components.ticketCarousel.constants.TICKET_COUNT;
const AnimatedBackgrounds = svs.tickets.next.components.animatedBackground.AnimatedBackgrounds;
const NavigationBack = svs.tur.NavigationBack;
const Button = svs.ui.ReactButton;
const _React = React,
  useCallback = _React.useCallback,
  useEffect = _React.useEffect,
  useRef = _React.useRef,
  useState = _React.useState;
const pickHolderStyle = {
  display: 'flex',
  position: 'relative',
  width: '100%',
  margin: '0 auto',
  zIndex: 1,
  pointerEvents: 'none'
};
const ticketHolderStyle = {
  position: 'relative',
  flexGrow: 1,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  width: '100%',
  pointerEvents: 'none'
};
const ticketInteractiveAreaStyle = {
  flexGrow: 1,
  width: '100%',
  pointerEvents: 'auto'
};
const getSafeSelectedTicketNumber = function (ticketNumber) {
  let fallbackTicketNumber = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  const selectedTicketNumber = parseInt(ticketNumber, 10);
  const fallbackNumber = parseInt(fallbackTicketNumber, 10);
  const safeFallbackNumber = Number.isFinite(fallbackNumber) && fallbackNumber > 0 ? fallbackNumber : 1;
  return Number.isFinite(selectedTicketNumber) && selectedTicketNumber > 0 ? (selectedTicketNumber - 1) % TICKET_COUNT + 1 : safeFallbackNumber;
};
const getInitialSelectedTicketNumber = () => getSafeSelectedTicketNumber(svs.tickets.next.utils.utils.getTicketStash(), 1);
const Pick = _ref => {
  var _match$params, _svs$tickets$data$mod;
  let history = _ref.history,
    location = _ref.location,
    match = _ref.match;
  const _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    accountBalance = _useState2[0],
    setAccountBalance = _useState2[1];
  const _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isPickAnimating = _useState4[0],
    setIsPickAnimating = _useState4[1];
  const _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2),
    pickedNumber = _useState6[0],
    setPickedNumber = _useState6[1];
  const pendingWagerIdRef = useRef(null);
  const selectedTicketNumberRef = useRef(getInitialSelectedTicketNumber());
  const initialSelectedTicketNumber = selectedTicketNumberRef.current;
  const formatCurrency = svs.utils.format.Currency;
  const isPlayer = svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER);
  const ticketType = match === null || match === void 0 || (_match$params = match.params) === null || _match$params === void 0 ? void 0 : _match$params.ticketType;
  const currentPath = (location === null || location === void 0 ? void 0 : location.pathname) || window.location.pathname;
  const availableTickets = ((_svs$tickets$data$mod = svs.tickets.data.moduleConfig) === null || _svs$tickets$data$mod === void 0 ? void 0 : _svs$tickets$data$mod.availableTickets) || [];
  const ticketInfo = availableTickets.find(ticket => {
    var _ticket$type, _ticket$alternativeUr;
    return ((_ticket$type = ticket.type) === null || _ticket$type === void 0 ? void 0 : _ticket$type.toLowerCase()) === (ticketType === null || ticketType === void 0 ? void 0 : ticketType.toLowerCase()) || ((_ticket$alternativeUr = ticket.alternativeUrl) === null || _ticket$alternativeUr === void 0 ? void 0 : _ticket$alternativeUr.toLowerCase()) === (ticketType === null || ticketType === void 0 ? void 0 : ticketType.toLowerCase());
  });
  const ticketTitle = (ticketInfo === null || ticketInfo === void 0 ? void 0 : ticketInfo.name) || (ticketInfo === null || ticketInfo === void 0 ? void 0 : ticketInfo.type);
  const routes = {
    [currentPath]: {
      text: "Start / ".concat(ticketTitle),
      navigate: () => history.push('/')
    }
  };
  const isDemo = (ticketInfo === null || ticketInfo === void 0 ? void 0 : ticketInfo.gameMode) === 'DEMO';
  const handleSelectedNumberChange = useCallback(ticketNumber => {
    const selectedNumber = getSafeSelectedTicketNumber(ticketNumber, selectedTicketNumberRef.current);
    selectedTicketNumberRef.current = selectedNumber;
    svs.tickets.next.utils.utils.stashTicket(selectedNumber);
  }, []);
  const getPlayPath = _ref2 => {
    let ticketNumber = _ref2.ticketNumber,
      wagerId = _ref2.wagerId;
    const selectedNumber = getSafeSelectedTicketNumber(ticketNumber, selectedTicketNumberRef.current);
    const skinId = svs.tickets.next.utils.utils.getSelectedTicketVariation(selectedNumber, ticketInfo) || 1;
    const playTicketType = (ticketInfo === null || ticketInfo === void 0 ? void 0 : ticketInfo.alternativeUrl) || (ticketInfo === null || ticketInfo === void 0 ? void 0 : ticketInfo.type) || ticketType;
    handleSelectedNumberChange(selectedNumber);
    if (wagerId !== 'demo') {
      if (!isPlayer) {
        svs.utils.paramHandler.set({
          key: 'betala',
          value: selectedNumber
        });
      } else {
        svs.utils.paramHandler.remove({
          key: 'betala'
        });
      }
    }
    return "/spela/".concat(playTicketType, "/").concat(wagerId, "?skinId=").concat(skinId, "&ticketNumber=").concat(selectedNumber);
  };
  const onAnimationDone = () => {
    const requestedWagerId = pendingWagerIdRef.current;
    const wagerId = requestedWagerId || (isDemo ? 'demo' : 'PENDING');
    pendingWagerIdRef.current = null;
    const ticketNumber = pickedNumber || selectedTicketNumberRef.current;
    history.push(getPlayPath({
      ticketNumber,
      wagerId
    }));
  };
  const requestPickAnimation = (wagerId, ticketNumber) => {
    if (isPickAnimating) {
      return;
    }
    pendingWagerIdRef.current = wagerId;
    setIsPickAnimating(true);
    setPickedNumber(ticketNumber || selectedTicketNumberRef.current);
  };
  const handleGift = () => {
    let giftUrl = "".concat(svs.core.urlMapping.get('trissGift'), "?lott=").concat(ticketInfo.type);
    const skinVariations = ticketInfo.variations;
    if (skinVariations) {
      const selectedNumber = getSafeSelectedTicketNumber(svs.tickets.next.utils.utils.getTicketStash(), selectedTicketNumberRef.current);
      const skinId = svs.tickets.next.utils.utils.getSelectedTicketVariation(selectedNumber, ticketInfo) || 1;
      giftUrl += ":".concat(skinId);
    }
    svs.utils.url.navigate(giftUrl);
  };
  const updateAccountBalance = useCallback(balance => {
    setAccountBalance(balance || 0);
  }, []);
  const getAccountBalance = useCallback(() => {
    if (!isPlayer) {
      updateAccountBalance(0);
      return;
    }
    svs.components.account_balance.get(true, updateAccountBalance);
  }, [isPlayer, updateAccountBalance]);
  useEffect(() => {
    svs.tickets.next.utils.utils.scrollTopContent();
    svs.tickets.next.utils.utils.showHeaders(true);
  }, []);
  useEffect(() => {
    getAccountBalance();
  }, [getAccountBalance]);
  return React.createElement(React.Fragment, null, React.createElement(NavigationBack, {
    brand: "next-lobby",
    routes: routes
  }), React.createElement("div", {
    style: pickHolderStyle
  }, React.createElement("div", {
    style: ticketHolderStyle
  }, React.createElement("div", {
    style: {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0
    }
  }, React.createElement("div", {
    style: {
      aspectRatio: '4 / 3',
      maxWidth: '700px',
      margin: '0 auto',
      width: '100%',
      position: 'relative'
    }
  }, React.createElement(AnimatedBackgrounds, {
    ticketInfo: ticketInfo
  }))), React.createElement("div", {
    style: ticketInteractiveAreaStyle
  }, React.createElement(TicketCarouselStage, {
    animatePicking: isPickAnimating,
    animationDoneCallback: onAnimationDone,
    initialSelectedNumber: initialSelectedTicketNumber,
    onPick: ticketNumber => requestPickAnimation(isDemo ? 'demo' : 'PENDING', ticketNumber),
    onSelectedNumberChange: handleSelectedNumberChange,
    ticketInfo: ticketInfo,
    ticketTitle: ticketTitle
  })), React.createElement(BottomSheet, {
    className: "triss-next-pick-bottom-sheet",
    hide: isPickAnimating
  }, React.createElement("div", {
    className: "padding-h-2",
    style: {
      paddingTop: '20px'
    }
  }, isPlayer && React.createElement("p", {
    className: "margin-top-0 margin-bottom-2"
  }, "Saldo: ".concat(formatCurrency(accountBalance), " kr")), React.createElement("div", {
    style: {
      display: 'flex',
      gap: '8px'
    }
  }, React.createElement("div", {
    style: {
      flex: 1
    }
  }, React.createElement(Button, {
    block: true,
    disabled: isPickAnimating,
    onClick: () => requestPickAnimation('demo'),
    transparent: true,
    type: "button"
  }, "Provspela")), React.createElement("div", {
    style: {
      flex: 1
    }
  }, React.createElement(Button, {
    block: true,
    disabled: isPickAnimating,
    onClick: handleGift,
    transparent: true,
    type: "button"
  }, "Ge bort")))), React.createElement("div", {
    className: "u-flex u-flex-justify-content-center u-flex-column padding-2"
  }, React.createElement(Button, {
    block: true,
    disabled: isPickAnimating,
    focus: true,
    onClick: () => requestPickAnimation(isDemo ? 'demo' : 'PENDING'),
    type: "button"
  }, "Betala ".concat(formatCurrency((ticketInfo === null || ticketInfo === void 0 ? void 0 : ticketInfo.price) || 0), " kr")))))));
};
setGlobal('svs.tickets.next.areas.pick.Pick', Pick);

 })(window);